const defaultState = {
  containerTypes: ['Standard', 'Open top', 'Refrigerated', 'Flat Rack', 'ISO Tank', 'Other'],
  containerSize: ['20DV', '40DV', '40HC', '45HC', 'Other'],
  commodity: ['General Dry Goods', 'White Goods', 'Raw Cotton', 'Cotton, Yarn',
    'Rice & other grains, flour, sugar', 'Textiles & ready-made garments', 'Rice Bran',
    'Purified Terephtalic Acid (PTA)', 'Oxidizing substances, IMCO class 5', 'Gases-2.1',
    'Gases-2.2', 'Gases-2.3', 'Flammable Liquids-3', 'Flammable Solids-4.1',
    'Flammable Solids Self Heat-4.2', 'Emit Flammable Gases with Water-4.3', 'Toxic substances-6.1',
    'Infectious substances-6.2', 'Radioactive material-7', 'Corrosives-8',
    'Miscellaneous dangerous goods-9'],
  cargo: ['Container cargo', 'Liquid bulk', 'Dry bulk', 'Ro-ro'],
  documentTypes: [
    { id: 'CHECKLIST', name: 'Checklist', type: 'ShippingLine' },
    { id: 'SHIPPING_BILL', name: 'Shipping Bill', type: 'ShippingLine' },
    { id: 'DRAFT_BL_OF_LADING', name: 'Draft bill of lading', type: 'ShippingLine' },
    { id: 'BL_OF_LADING', name: 'Final bill of lading', type: 'ShippingLine' },
    { id: 'VGM', name: 'VGM', type: 'Shipper' },
    { id: 'SHIPPING_INSTRUCTION', name: 'Shipping Instruction', type: 'Shipper' },
    { id: 'PACKING_LIST', name: 'Packing List', type: 'Shipper' },
    { id: 'COMMERCIAL_INVOICE', name: 'Commercial Invoice', type: 'Shipper' },
    { id: 'IMPORTER_SECURITY_FILING', name: 'Importer Security Filling', type: 'Shipper' },
    {
      id: 'SHIPPERS_EXPORT_DECLARATION', name: 'Shippers Export Declaration (SED)',
      type: 'Shipper'
    },
    { id: 'INSPECTION_CERTIFICATE', name: 'Inspection Certificate', type: 'Shipper' },
    { id: 'APEDA', name: 'Apeda', type: 'Shipper' },
    { id: 'PHYTO', name: 'Phyto', type: 'Shipper' },
    { id: 'FORM_11', name: 'Form 11', type: 'Shipper' },
    { id: 'FORM_13', name: 'Form 13', type: 'Shipper' },
  ],
  cargoTypes: [
    { key: 'General', label: 'General' },
    { key: 'Haz', label: 'Haz' },
  ],
  product: {
    General: [
      { key: 'General Dry Goods', label: 'General Dry Goods' },
      { key: 'White Goods', label: 'White Goods' },
      { key: 'Raw Cotton', label: 'Raw Cotton' },
      { key: 'Cotton, Yarn', label: 'Cotton, Yarn' },
      { key: 'Rice and other grains, flour, sugar', label: 'Rice and other grains, flour, sugar' },
      { key: 'Textiles', label: 'Textiles' },
      { key: 'Rice Bran', label: 'Rice Bran' },
      { key: 'Pharmaceutical', label: 'Pharmaceutical' },
      { key: 'Fruit Pulp', label: 'Fruit Pulp' },
      { key: 'Steel', label: 'Steel' },
      { key: 'Pipes', label: 'Pipes' },
      { key: 'Sheet', label: 'Sheet' },
      { key: 'Dehydrated Onion', label: 'Dehydrated Onion' },
      { key: 'Spices', label: 'Spices' },
    ],
    Haz: [
      {
        key: 'Oxidising Substance, IMCO Class 5', label: 'Oxidising Substance, IMCO Class 5'
      },
      {
        key: 'Gases - 2.1', label: 'Gases - 2.1'
      },
      {
        key: 'Gases - 2.2', label: 'Gases - 2.2'
      },
      {
        key: 'Gases - 2.3', label: 'Gases - 2.3'
      },
      {
        key: 'Flammable Liquids - 3', label: 'Flammable Liquids - 3'
      },
      {
        key: 'Flammable Solids - 4.1', label: 'Flammable Solids - 4.1'
      },
      {
        key: 'Flammable Solids Self Heat - 4.2', label: 'Flammable Solids Self Heat - 4.2'
      },
      {
        key: 'Emit Flammable Gases with water - 4.3',
        label: 'Emit Flammable Gases with water - 4.3'
      },
      {
        key: 'Oxidizing Substances and Organic Peroxides - 5',
        label: 'Oxidizing Substances and Organic Peroxides - 5'
      },
      {
        key: 'Toxic Substance - 6.1', label: 'Toxic Substance - 6.1'
      },
      {
        key: 'Infectious Substance - 6.2', label: 'Infectious Substance - 6.2'
      },
      {
        key: 'Radioactive Material - 7', label: 'Radioactive Material - 7'
      },
      {
        key: 'Corrosives - 8', label: 'Corrosives - 8'
      },
      {
        key: 'Misc dangerous goods - 9', label: 'Misc dangerous goods - 9'
      },
    ],
    Other: [],
  },
  currency: [
    { id: 'INR', name: 'INR' },
    { id: 'USD', name: 'USD' }
  ],
  allCurrencyData: [
    { id: 'INR', name: 'INR' },
    { id: 'USD', name: 'USD' },
    { id: 'AUD', name: 'AUD' },
    { id: 'CAD', name: 'CAD' },
    { id: 'DKK', name: 'DKK' },
    { id: 'EUR', name: 'EUR' },
    { id: 'GBP', name: 'GBP' },
    { id: 'MAD', name: 'MAD' },
    { id: 'NZD', name: 'NZD' },
    { id: 'PKR', name: 'PKR' },
    { id: 'TND', name: 'TND' },
    { id: 'ZAR', name: 'ZAR' },
    { id: 'JPY', name: 'JPY' }
  ],

  containerTypesKeyVal: [
    { key: 'STANDARD', label: 'Standard' },
    { key: 'ISO_TANKS', label: 'ISO Tanks' },
    { key: 'REFRIGERATED', label: 'Refrigerated' },
    { key: 'OPEN_TOP', label: 'Open Top' },
    { key: 'FLAT_RACK', label: 'Flat Rack' },
    { key: 'HEAVY_DUTY', label: 'Heavy Duty' },
    { key: 'FLEXI', label: 'Flexi' },
    { key: 'OTHER', label: 'Other' },
  ],
  vehicleTypes: ['Truck', 'Rail', 'Vessel'],
};

export default function (state: any = defaultState, action) {
  return state;
}
